import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from '../../Utilities/DraggableModal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import FuncFetch from '../../Utilities/funcFetch';
import { useMsal } from '@azure/msal-react';
import { Alert } from 'react-bootstrap';

const AddEditCollector = ({ collector, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const { instance, accounts } = useMsal();
    const [formData, setFormData] = useState(collector);

    useEffect(() => {
        if (collector) {
            setFormData({
                ...collector
            });
        }
    // eslint-disable-next-line
    }, [collector]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);
        FuncFetch(
            `${process.env.REACT_APP_API_URL}/Admin/PatchCollector`,
            {
                collectorid: formData.collector,
                group: formData.groupName
            },
            'PATCH',
            formData,
            instance,
            accounts
        )
        .then(() => {
            setLoading(false);
            setSuccess('Collector saved successfully!');
            setTimeout(() => {
                setSuccess(null);
                onClose();
            }, 2000);
        })
        .catch((error) => {
            console.error('Error saving collector:', error);
            setLoading(false);
            setError('Failed to save collector. Please try again.');
        });
    };

    return (
        <Modal show onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Edit Collector</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="collector" className="mb-3">
                                <Form.Label>Collector ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="collector"
                                    value={formData.collector}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="fullName" className="mb-3">
                                <Form.Label>Full Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="fullName"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="emailAddress" className="mb-3">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="emailAddress"
                                    value={formData.emailAddress}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="groupName" className="mb-3">
                                <Form.Label>Group Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="groupName"
                                    value={formData.groupName}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="stateLocation" className="mb-3">
                                <Form.Label>State Location</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="stateLocation"
                                    value={formData.stateLocation || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="primaryProject" className="mb-3">
                                <Form.Label>Primary Project</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="primaryProject"
                                    value={formData.primaryProject || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="secondProject" className="mb-3">
                                <Form.Label>Second Project</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="secondProject"
                                    value={formData.secondProject || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="ClaimDistCount" className="mb-3">
                                <Form.Label>Claim Distribution Count</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="claimDistCount"
                                    value={formData.claimDistCount}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="collectionMin" className="mb-3">
                                <Form.Label>Collection Min</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="collectionMin"
                                    value={formData.collectionMin}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="collectionMax" className="mb-3">
                                <Form.Label>Collection Max</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="collectionMax"
                                    value={formData.collectionMax}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <h5 className="mt-4 mb-3">Permissions</h5>
                    <Row>
                        <Col md={4}>
                            <Form.Group controlId="active" className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    name="active"
                                    label="Active"
                                    checked={formData.active}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="isAdmin" className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    name="isAdmin"
                                    label="Admin"
                                    checked={formData.isAdmin}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="isPaymentAdmin" className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    name="isPaymentAdmin"
                                    label="Payment Admin"
                                    checked={formData.isPaymentAdmin}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={4}>
                            <Form.Group controlId="isCollectorAdmin" className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    name="isCollectorAdmin"
                                    label="Collector Admin"
                                    checked={formData.isCollectorAdmin}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="canReassign" className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    name="canReassign"
                                    label="Can Reassign"
                                    checked={formData.canReassign}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="canClose" className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    name="canClose"
                                    label="Can Close"
                                    checked={formData.canClose}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={4}>
                            <Form.Group controlId="spanish" className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    name="spanish"
                                    label="Spanish"
                                    checked={formData.spanish}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {loading && <Spinner animation="border" />}
                    {error && <Alert variant="warning">{error}</Alert>}
                    {success && <Alert variant="success">{success}</Alert>}

                    <div className="d-flex justify-content-end gap-2 mt-3">
                        <Button variant="primary" type="submit" disabled={loading}>
                            Save
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddEditCollector;